import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import customizationReducer from './reducer/customizationReducer';
import { authReducer, dashboardReducer, resetReducer, changePasswordReducer, otpVerificationReducer } from './reducer/userReducer';

// ==============================|| REDUX - MAIN STORE ||============================== //
const reducer = combineReducers({
    customization: customizationReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    reset: resetReducer,
    changePassword: changePasswordReducer,
    otpVerification: otpVerificationReducer
});
const initialState = {};
const middleware = [thunk];
const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));
export default store;
